import html2canvas from 'html2canvas';
import * as JSpdf from 'jspdf';
import DatePicker from 'material-ui/DatePicker';
import MenuItem from 'material-ui/MenuItem';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import React, { Component } from 'react';
import { connect } from "react-redux";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import * as jsPDF from 'jspdf'
// import '../../thirdparty/jsencrypt.min.js'
import * as actions from '../../actions/actions.jsx';
import s from '../../services/allservices.jsx';
import '../../stylesheet/cardactivity.css';
import LeftLink from '../leftlink/leftlink.jsx';
import Loader from '../loader/loader.jsx';
import AuthNavbar from '../navigation/authnavigation.jsx';
import CardInfo from '../dashboard/cardlist'
import { getClientId, getClientSecret, buildClientHeader } from '../../utils/clientAuth.js'

const styles = {
    block: {
        maxWidth: 250,
    },
    radioButton: {
        marginBottom: 5,
        marginTop: 5,
        width: "33%",
        display: "inline"
    },
    blockmargin: {
        marginBottom: 10,
        marginRight: 10
    },
    labelStyle: {
        padding: 0,
        color: "#fff",
        marginTop: 20
    },
    inputStle: {
        marginRight: 5,
        marginTop: 10
    },
    groupstyle: {
        display: "flex",
        width: "100%"
    },
    radioIcon: {
        fill: "#333"
    },
    calendarStyle: {
        // backgroundColor:"#333"
    },
    calendarTextStyle: {
        color: "#fff",
        // backgroundColor:"#333"
    }
};

const mapStateToProps = state =>
({
    publicKey: state.publicKey.publicKey,
    profileState: state.getProfileReducer.profileState,
    cardState: state.getCardReducer.cardState,
    cardactivity: state.getCardActivityReducer.cardactivity
})
const mapDispatchToProps = dispatch =>
({
    fetchCard(state) {
        dispatch(
            actions.getCardAction(state)
        )
    },
    fetchCardActivity(cardDetailId, startDate, endDate, statementPeriod, transactionType) {

        dispatch(
            actions.getCardActivity(cardDetailId, startDate, endDate, statementPeriod, transactionType)
        )
    },

})

class Activity extends Component {
    constructor(props) {
        super(props);
        this.state = {
            initialvalue: '',
            value: '',
            loader: true,
            disabled: true,
            cardDetailsId: 1,
            selectedCard: [],
            selectedNewCard: [],
            cardactivity: {},
            QuickLoad: false,
            QuickLoad1: false,
            statementPeriod: 7,
            pageNo: 0,
            pageSize: 1000,
            activityFromDate: "",
            transactionToDate: "",
            transactionFromDate: "",
            activityToDate: "",
            value4: 'all',
            todatestate: true,
            cardInUse: [],
            selectedOption: "tab1",
            transactionData: [],
            transactionType: ""
        }
    }

    handleSelect = (event, index, value) => {
        const { cardState } = this.props

        for (let i = 0; i < cardState.body.length; i++) {
            if (cardState.body[i].cardDetailsId === value) {
                this.setState({
                    cardInUse: cardState.body[i]
                })
            }
        }
        this.setState({ cardDetailsId: value }, () => {
            this.setState({
                loader: true
            })

            this.props.fetchCardActivity(this.state.cardDetailsId, this.state.activityFromDate, this.state.activityToDate, this.state.statementPeriod, this.state.transactionType)

        }, () => {

        });

    }
    // handleChange7(e) {
    //     var date5 = new Date();
    //     var ISostring5 = date5.toISOString();
    //     var IsoTrim5 = ISostring5.split('T')[0]
    //     this.setState({
    //         selectedOption: e.target.value,
    //         transactionType: "P",
    //         activityFromDate: IsoTrim5,
    //         loader: true
    //     }, () => {
    //         this.props.fetchCardActivity(this.state.cardDetailsId, this.state.activityFromDate, this.state.activityToDate, this.state.statementPeriod, this.state.transactionType)
    //     }, () => {
    //         setTimeout(() => {

    //             this.setState({ loader: false })
    //         }, 3500)
    //     })
    // }

// handleChange7(e) {
//     this.setState({
//         selectedOption: e.target.value,
//         transactionType: "P",
//         activityFromDate: this.converDate(this.state.pickedFromDate || new Date()),
//         loader: true
//     }, () => {
//         this.props.fetchCardActivity(this.state.cardDetailsId, this.state.activityFromDate, this.state.activityToDate, this.state.statementPeriod, this.state.transactionType)
//     }, () => {
//         setTimeout(() => {
//             this.setState({ loader: false })
//         }, 3500)
//     })
// }

handleChange7(e) {
    this.setState({
        selectedOption: e.target.value,
        transactionType: "P",
        // activityFromDate: this.state.pickedFromDate
        //     ? this.converDate(this.state.pickedFromDate)
        //     : new Date().toISOString().split('T')[0],
        activityFromDate: this.getActivityFromDate(),
        loader: true
    }, () => {
        this.props.fetchCardActivity(this.state.cardDetailsId, this.state.activityFromDate, this.state.activityToDate, this.state.statementPeriod, this.state.transactionType)
    }, () => {
        setTimeout(() => {
            this.setState({ loader: false })
        }, 3500)
    })
}

    handleChange8(e) {
        var date6 = new Date();
        var ISostring6 = date6.toISOString();
        var IsoTrim6 = ISostring6.split('T')[0]
        this.setState({
            selectedOption: e.target.value,
            transactionType: "A",
            activityFromDate: IsoTrim6,
            loader: false
        }, () => {
            this.fetchFailedTransactions()
        }, () => {
            setTimeout(() => {

                this.setState({ loader: false })
            }, 3500)
        })
    }
    fetchFailedTransactions = () => {
        this.setState({
            loader: true
        })


        let state = {
            fromDate: this.state.transactionFromDate,
            toDate: this.state.transactionToDate,
            cardDetailsId: this.state.cardDetailsId,
            statementPeriod: this.state.statementPeriod,
            pageNumber: this.state.pageNo,
            pageSize: this.state.pageSize,
        }

        let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
        let traceId = getClientId();
        fetch(plink + s.get_FailedTransactions, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': "Token " + localStorage.getItem('token'),
                'X-Trace-Id': traceId,
                'X-Client-APP': buildClientHeader(),
            }),
            body: JSON.stringify(state)
        })
            .then(response => {
                if (response.status === 204) {

                    this.setState({
                        loader: false,
                        transactionData: []

                    })
                    return;
                }

                response.json().then(json => {


                    if (response.status === 200) {

                        this.setState({

                            loader: false,
                            transactionData: json.content,
                            totalPages: json.totalPages,
                            number: json.number,
                            first: json.first,
                            last: json.last,
                        })
                        window.scrollBy(0, 0)
                    }
                    else if (response.status === 204) {

                        this.setState({
                            loader: false,
                            transactionData: []

                        })
                    }

                    else {
                        this.setState({
                            loader: false,
                            transactionData: []
                        })
                        toast.error(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                    }
                })
            })

    }

    handleSelectmonth = (event, index, value) => {
        this.setState({
            loader: true
        })
        var date7 = new Date();
        var ISostring7 = date7.toISOString();
        var IsoTrim7 = ISostring7.split('T')[0]
        // this.setState({
        //     statementPeriod: value,
        //     activityFromDate: IsoTrim7,
        //     transactionFromDate: IsoTrim7,
        // }, () => {
            this.setState({
    statementPeriod: value,
    activityFromDate: IsoTrim7,
    transactionFromDate: IsoTrim7,
    activityToDate: "",
    pickedFromDate: null,
}, () => {


            if (this.state.statementPeriod === 0 && this.state.selectedOption === "tab1") {
                const state = {
                    activityFromDate: this.state.activityFromDate,
                    activityToDate: this.state.activityToDate,
                    cardDetailsId: this.state.cardDetailsId,
                    statementPeriod: this.state.statementPeriod

                }

                let token = "Token " + localStorage.getItem('token')
                let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
                let traceId = getClientId();
                fetch(plink + s.get_cardactivity, {
                    method: "POST",
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': token,
                        'X-Trace-Id': traceId,
                        'X-Client-APP': buildClientHeader(),
                    },
                    body: JSON.stringify(state)

                })
                    .then(response => {
                        toast.error(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                        this.setState({
                            loader: false
                        })
                    })
            }
            else if (this.state.statementPeriod && this.state.selectedOption === "tab2") {
                this.setState({
                    pageNo: 0,
                })

                this.fetchFailedTransactions()
            }
            else if (this.state.statementPeriod === 0 && this.state.selectedOption === "tab2") {
                this.setState({
                    pageNo: 0,
                })
                this.fetchFailedTransactions()
            }
            else {
                this.setState({
                    loader: true
                })
                this.props.fetchCardActivity(this.state.cardDetailsId, this.state.activityFromDate, this.state.activityToDate, this.state.statementPeriod, this.state.transactionType)

                setTimeout(() => {

                    this.setState({ loader: false })
                }, 3500)
            }

        });
    }
    handleChange = (event) => {
        this.setState({
            value4: event.target.value

        })
    };
    handledate = (e, date) => {
        this.setState({
            activityFromDate: this.converDate(date),
            activityToDate: this.converDate(date)
        }, () => {
            if (this.state.activityFromDate !== "" && this.state.activityToDate !== " ") {
                this.setState({
                    disabled: false
                })
            }
            else {
                this.setState({
                    disabled: true
                })
            }

        })



    }
    handlecardactivity = () => {

        this.setState({
            loader: true,
            disabled: true,
        })

        // if ((Date.parse(this.state.toDate)) < (Date.parse(this.state.fromDate))) {
        //     this.setState({
        //         todatestate: false,
        //     })
        // }
        if (Date.parse(this.state.activityToDate) < Date.parse(this.state.activityFromDate)) {
    this.setState({
        todatestate: false,
        loader: false,
        disabled: false,
    })
}
        else if (this.state.selectedOption === "tab2") {
            this.setState({
                statementPeriod: 0,
                pageNo: 0,

            }, () => {
                this.fetchFailedTransactions()
                setTimeout(() => {

                    this.setState({ loader: false })
                }, 3500)

            })
        }
        else {

            this.setState({
                activityFromDate: this.state.activityFromDate,
                activityToDate: this.state.activityToDate,
                applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                cardDetailsId: this.state.cardDetailsId,
                statementPeriod: 0

            }, () => {
                this.setState({
                    loader: true,
                    todatestate: true
                })
                this.props.fetchCardActivity(this.state.cardDetailsId, this.state.activityFromDate, this.state.activityToDate, this.state.statementPeriod, this.state.transactionType)

            }, () => {
                setTimeout(() => {

                    this.setState({ loader: false })
                }, 3500)
            })
        }
    }

    componentDidMount() {

        let _this = this
        _this.setState({
            loader: true,
        })
        var date4 = new Date();
        var ISostring4 = date4.toISOString();
        var IsoTrim4 = ISostring4.split('T')[0]
        let foo = ""
        foo = this.props.location.state

        this.setState({
            cardDetailsId: foo === undefined ? this.props.cardState.body[0].cardDetailsId : foo,
            cardInUse: this.props.cardState.body[0],
            transactionType: "P",
            initialvalue: "initial",
            activityFromDate: IsoTrim4,
            // selectedCard: foo === undefined ? this.props.cardState.body[0].cardDetailsId : foo,
        }, () => {
            for (let i = 0; i < this.props.cardState.body.length; i++) {


                if (this.props.cardState.body[i].cardDetailsId === this.state.cardDetailsId) {
                    this.setState({
                        // cardInUse: cardState.body[i],
                        selectedCard: this.props.cardState.body[i],
                        selectedNewCard: [this.props.cardState.body[i]],

                        // initialvalue: "changed",
                        // cardDetailsId: value
                    }, () => {


                    })
                }
            }

            _this.props.fetchCardActivity(_this.state.cardDetailsId, _this.state.activityFromDate, _this.state.activityToDate, _this.state.statementPeriod, _this.state.transactionType)

            setTimeout(() => {

                _this.setState({ loader: false })
            }, 3500)

        })


    }
    // handleFromDate = (e, date) => {
    //     var date1 = new Date(date);
    //     this.setState({
    //         activityFromDate: this.converDate(date),
    //         fromDate: date1.toLocaleDateString(),
    //         transactionFromDate: this.converDate1(date)
    //     }, () => {
    //         if (this.state.activityFromDate.length !== 0 && this.state.activityToDate.length !== 0) {
    //             this.setState({
    //                 disabled: false

    //             })
    //         }
    //         else {
    //             this.setState({
    //                 disabled: true
    //             })
    //         }

    //     })
    // }
    handleFromDate = (e, date) => {
    var date1 = new Date(date);
    this.setState({
        activityFromDate: this.converDate(date),
        fromDate: date1.toLocaleDateString(),
        transactionFromDate: this.converDate1(date),
        pickedFromDate: date
    }, () => {
        if (this.state.activityFromDate.length !== 0 && this.state.activityToDate.length !== 0) {
            // this.setState({ disabled: false })
                this.setState({ disabled: !this.state.activityToDate })

        }
        else {
            // this.setState({ disabled: true })
                this.setState({ disabled: !this.state.activityToDate })

        }
    })
}
    // handleToDate = (e, date) => {
    //     var dob1 = new Date(date);
    //     this.setState({
    //         activityToDate: this.converDate(date),
    //         toDate: dob1.toLocaleDateString(),
    //         transactionToDate: this.converDate1(date)
    //     }, () => {

    //         if (this.state.activityFromDate.length !== 0 && this.state.activityToDate.length !== 0) {
    //             this.setState({
    //                 disabled: false

    //             })
    //         }
    //         else {
    //             this.setState({
    //                 disabled: true
    //             })
    //         }

    //     })
    // }
    handleToDate = (e, date) => {
    var dob1 = new Date(date);
    this.setState({
        activityToDate: this.converDate(date),
        toDate: dob1.toLocaleDateString(),
        transactionToDate: this.converDate1(date),
    }, () => {
        this.setState({
            activityFromDate: this.getActivityFromDate(),
            disabled: !this.state.pickedFromDate
        })
    })
}
    comparedate = () => {
        const { activityFromDate, activityToDate } = this.state
        if (Date.parse(activityToDate) <= Date.parse(activityFromDate)) {

        }
    }
    converDate(date) {
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();

        return [
            (mm > 9 ? '' : '0') + mm,
            (dd > 9 ? '' : '0') + dd,
            date.getFullYear()
        ].join('/');
    }
    getActivityFromDate = () => {
    if (this.state.pickedFromDate) return this.converDate(this.state.pickedFromDate);
    if (this.state.activityToDate) return this.converDate(new Date());
    return new Date().toISOString().split('T')[0];
}
    converDate1(date) {
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();

        return [
            date.getFullYear(),
            (mm > 9 ? '' : '0') + mm,
            (dd > 9 ? '' : '0') + dd,

        ].join('-');
    }
    formatDate = (date) => {
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();
        return [

            (dd > 9 ? '' : '0') + dd,
            (mm > 9 ? '' : '0') + mm,
            date.getFullYear()
        ].join('/');
    }
    handleChangeMinDate = (event, date) => {
        this.setState({
            statementFromDate: this.converDate(date),
        });
    };
    componentDidUpdate(prevProps) {
    }
    removetodate = () => {
        this.setState({
            todatestate: true
        })
    }
    handleChangeMaxDate = (event, date) => {
        this.setState({
            statementTodDate: date,
        });
    }
    handleSelect1 = (event, index, value) => {
        this.setState({ loader: true })

        const { cardState } = this.props
        for (let i = 0; i < cardState.body.length; i++) {


            if (cardState.body[i].cardDetailsId === value) {
                this.setState({
                    cardInUse: cardState.body[i],
                    selectedCard: cardState.body[i],
                    selectedNewCard: [cardState.body[i]],
                    initialvalue: "changed",
                    cardDetailsId: value
                })
            }
        }

        let _this = this

        this.setState({
            cardDetailsId: value
        }, () => {

            for (let i = 0; i < cardState.body.length; i++) {
                if (this.state.cardDetailsId === cardState.body[i].cardDetailsId) {

                    this.setState({

                        selectedCard: cardState.body[i]
                    }, () => {



                        this.state.selectedOption === "tab1" ?
                            _this.props.fetchCardActivity(cardState.body[i].cardDetailsId, _this.state.activityFromDate, _this.state.activityToDate, _this.state.statementPeriod, _this.state.transactionType)
                            :
                            _this.fetchFailedTransactions()
                    }, () => {
                        setTimeout(() => {

                            _this.setState({ loader: false })
                        }, 3500)
                    })
                }
            }
        });

    }

    componentWillReceiveProps(nextProps) {
        let _this = this

        this.setState({
            loader: true
        })
        try {
            if (_this.state.initialvalue === 'initial') {

                if (nextProps.cardState && nextProps.cardState.length !== 0) {
                    this.setState({
                        loader: false,
                        selectedCard: this.state.selectedCard.length === 0 ? nextProps.cardState.body[0] : this.state.selectedCard,
                        value: nextProps.cardState.body[0].cardDetailsId,
                        selectedNewCard: this.state.selectedNewCard.length === 0 ? nextProps.cardState.body[0] : this.state.selectedNewCard,
                    })
                }
            }
            else {

                this.setState({
                    loader: false
                })
                // if (nextProps.cardState && nextProps.cardState.length !== 0) {
                //     for (let i = 0; i < nextProps.cardState.body.length; i++) {
                //         if (nextProps.cardState.body[i].cardDetailsId === _this.state.value) {
                //             
                //             this.setState({                              
                //                 loader: false,
                //                 selectedCard: nextProps.cardState.body[i]
                //             })
                //         }
                //     }
                // }
            }
        } catch (e) {

        }

    }
    handleDownload() {

        //debugger
        // setTimeout(() => {
        console.log("download pdf")
        if (this.props.cardactivity.body.transactions.length !== 0) {
            this.setState({
                quickLoad: true,
            });
            var date7 = new Date();
            var ISostring7 = date7.toISOString();
            var IsoTrim7 = ISostring7.split("T")[0];
            console.log('IsoTrim7 value', IsoTrim7)
            // this.setState(
            //     {
            //         // activityFromDate: IsoTrim7,
            //                 activityFromDate: this.converDate(this.state.pickedFromDate || new Date()),

            //     },
            this.setState({
    quickLoad: true,
});
this.setState(
    {
        activityFromDate: this.getActivityFromDate(),
    },
                () => {
                    const state = {
                        activityFromDate: this.state.activityFromDate,
                        activityToDate: this.state.activityToDate,
                        cardDetailsId: this.state.cardDetailsId,
                        statementPeriod: this.state.statementPeriod,
                        applicationId: "212fau",
                        transactionType: 'P'
                    };
                    let token = "Token " + localStorage.getItem("token");
                    let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
                    let traceId = getClientId();

                    fetch(plink + s.DownloadPDF, {
                        method: "POST",
                        headers: {
                            "content-type": "application/json",
                            Authorization: token,
                            'X-Trace-Id': traceId,
                            'X-Client-APP': buildClientHeader(),

                        },
                        body: JSON.stringify(state),
                    }).then((response) => {
                        console.log('download PDF response', response)
                        if (response.status === 200) {
                            // eslint-disable-next-line
                            response.blob().then(blob => {
                                console.log('PDF blob', blob)
                                let url = window.URL.createObjectURL(blob);
                                let a = document.createElement('a');
                                a.href = url;
                                setTimeout(() => {
                                    a.setAttribute('download', `PostedTransactions.pdf`)
                                    a.click();
                                    this.setState({ quickLoad: false });
                                }, 2000);

                            });

                        }
                        else if (response.status === 422) {
                            response.json().then(json => {
                                toast.error(json.message, {
                                    position: "top-right",
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    draggablePercent: 60
                                })

                            })
                            this.setState({
                                quickLoad: false,
                            });
                        }
                        else if (response.status === 401) {
                            if (this.props.history !== undefined) { this.props.history.push('/SessionOut') }
                        } else {
                            toast.error(response.headers.get('message'), {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                draggablePercent: 60
                            })
                            this.setState({ quickLoad: false });
                        }

                    });
                }
            )
        } else {
            toast.error("No content available for download.", {
                position: "top-right",
                draggablePercent: 60,
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
            });
        }
    }

    handleDownloadFailed = () => {

        if (this.state.transactionData && this.state.transactionData.length > 0) {

            this.setState({
                quickLoad1: true,
            });
            const state = {
                activityFromDate: this.state.activityFromDate,
                activityToDate: this.state.activityToDate,
                cardDetailsId: this.state.cardDetailsId,
                statementPeriod: this.state.statementPeriod,
                applicationId: "212fau",
                pageNumber: this.state.pageNo,
                pageSize: this.state.pageSize,
            };

            let token = "Token " + localStorage.getItem("token");
            let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
            let traceId = getClientId();

            fetch(plink + s.FailedDownloadPDF, {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    Authorization: token,
                    'X-Trace-Id': traceId,
                    'X-Client-APP': buildClientHeader(),
                },
                body: JSON.stringify(state),
            }).then((response) => {
                console.log(' failed records download PDF response', response)
                if (response.status === 200) {
                    // eslint-disable-next-line
                    response.blob().then(blob => {
                        console.log(' Failed PDF blob', blob)
                        let url = window.URL.createObjectURL(blob);
                        let a = document.createElement('a');
                        a.href = url;
                        setTimeout(() => {
                            a.setAttribute('download', `FailedTransactions.pdf`)
                            a.click();
                            this.setState({ quickLoad1: false });
                        }, 2000);

                    });

                }
                else if (response.status === 422) {
                    response.json().then(json => {
                        toast.error(json.message, {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            draggablePercent: 60
                        })

                    })
                    this.setState({
                        quickLoad1: false,
                    });
                }
                else if (response.status === 401) {
                    if (this.props.history !== undefined) { this.props.history.push('/SessionOut') }
                } else {
                    toast.error(response.headers.get('message'), {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        draggablePercent: 60
                    })
                    this.setState({ quickLoad1: false });
                }

            });
        } else {
            toast.error("No content available for download.", {
                position: "top-right",
                draggablePercent: 60,
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
            });
        }
    }

    dec() {
        let _this = this
        this.setState({
            pageNo: _this.state.pageNo - 1,
            showBtn: false,
        }, () => {
            _this.fetchFailedTransactions()


        });
    }
    inc(e) {
        // 
        let _this = this
        this.setState({
            pageNo: _this.state.pageNo + 1,
            showBtn: false
        },
            () => {


                _this.fetchFailedTransactions()
            });

    }

    handleShowMeOption = () => {
    }
    render() {
        const { cardState, cardactivity } = this.props

        console.log('CardState', cardState)

        const { todatestate, cardDetailsId, selectedCard, value4, cardInUse } = this.state
        console.log('selectedCard', selectedCard)
        console.log('cardDetailsId', cardDetailsId)
        console.log('value4', value4)
        const { profileState } = this.props
        console.log("profilestate", profileState)

        return (
            <div className="row" >
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                />
                <div className="col-sm-12 m-0 p-0">
                    <AuthNavbar />
                </div>
                <div className="container" style={{}}>
                    <div className="row pb-5">
                        {/* <div className="col-sm-3 box-shadow-style nopadding" style={{ minHeight: "470px" }}>
                            <LeftLink />
                        </div> */}
                        <div className="col-md-12">
                            <div className='container'>
                                <div className="header-style p-3 mt-2">
                                    <h4 className='logmainheading mainheading'>
                                        My Card Activity
                                    </h4>
                                    <p>
                                        Below is your card balance. You can search for all transactions or you can search by debits or credits only. Simply enter a statement period and click on the ‘Show’ button.

                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12" style={{ padding: "0px 30px" }}>
                            <div className="row" style={{ padding: "12px 0px", minHeight: "476px" }}>

                                {cardState.status === 200 && cardState.body.length !== 0 && selectedCard.length !== 0 ?

                                    <div className="col-sm-12  pr-0 mr-0">
                                        <div className="card-activity ">
                                            <div className="col-md-4" >

                                                <div className="" >
                                                    <SelectField
                                                        floatingLabelText=""
                                                        onChange={this.handleSelect1}
                                                        className="input-width"
                                                        name="Selected Card"
                                                        autoComplete='none'
                                                        value={cardDetailsId}>
                                                        {cardState.body.map((value, i) =>
                                                            <MenuItem className="menuitem" value={cardState.body[i].cardDetailsId} primaryText={cardState.body[i].cardNumber} key={i} />
                                                        )}
                                                    </SelectField>
                                                </div>



                                            </div>
                                            <div className="col-md-12 col-sm-12 ">
                                                <div className="row">
                                                    <CardInfo
                                                        selectedNewCard={this.state.selectedNewCard} />
                                                </div>
                                            </div>




                                        </div>
                                    </div>
                                    : <Loader />}

                                <div className="col-md-12 pl-3 ml-3  pr-3 mr-0">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="row">
                                                <div className="col-md-2 nopadding" style={{ marginTop: "15px" }}>Statement Period</div>
                                                <div className="col-md-10">
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <SelectField

                                                                onChange={this.handleSelectmonth}
                                                                className="input-width"
                                                                name="statementPeriod"
                                                                autoComplete='none'
                                                                value={this.state.statementPeriod}
                                                            >
                                                                {/* <MenuItem value={1} primaryText="Select transfer status" /> */}
                                                                <MenuItem className="menuitem" value={0} primaryText="Select Duration" />
                                                                <MenuItem className="menuitem" value={1} primaryText="Today" />
                                                                <MenuItem className="menuitem" value={2} primaryText="Yesterday" />
                                                                <MenuItem className="menuitem" value={3} primaryText="Last Week  " />
                                                                <MenuItem className="menuitem" value={4} primaryText="This Month" />
                                                                <MenuItem className="menuitem" value={5} primaryText="This Year" />
                                                                <MenuItem className="menuitem" value={6} primaryText="Last Month" />
                                                                <MenuItem className="menuitem" value={7} primaryText="Last 3 Months" />
                                                                <MenuItem className="menuitem" value={8} primaryText="Last 6 Months" />
                                                                <MenuItem className="menuitem" value={9} primaryText="Last 9 Months" />
                                                                <MenuItem className="menuitem" value={10} primaryText="Last 12 Months" />
                                                                <MenuItem className="menuitem" value={11} primaryText="Last 24 Months" />



                                                            </SelectField>

                                                        </div>
                                                        <div className="col-md-2 text-right" style={{ padding: "7px 13px" }}>
                                                            <b>Show Me</b>
                                                        </div>
                                                        <div className="col-md-6 m-0 p-0 pl-2">

                                                            <div className="row">
                                                                <RadioButtonGroup name="shipSpeed" defaultSelected="all" style={styles.groupstyle} onChange={this.handleChange.bind(this)}>

                                                                    <RadioButton
                                                                        value="all"
                                                                        label="All"
                                                                        style={styles.radioButton}
                                                                        iconStyle={styles.radioIcon}
                                                                        valueSelected="all"

                                                                    />
                                                                    <RadioButton
                                                                        value="debit"
                                                                        label="Debit"
                                                                        style={styles.radioButton}
                                                                        iconStyle={styles.radioIcon}
                                                                        valueSelected="debit"

                                                                    />
                                                                    <RadioButton
                                                                        value="credit"
                                                                        label="Credit"
                                                                        style={styles.radioButton}
                                                                        iconStyle={styles.radioIcon}
                                                                        valueSelected="credit"

                                                                    />
                                                                </RadioButtonGroup>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-sm-3">
                                                    <div className="row input-group" >
                                                        <div className="col-sm-2 activityinput" >
                                                            <i className="fa fa-calendar text-dark " aria-hidden="true"></i>
                                                        </div>
                                                        <div className="col-sm-10 nopadding" >
                                                            <DatePicker
                                                                openToYearSelection={true}
                                                                hintText="From Date"
                                                                container="inline"
                                                                name="activityFromDate"
                                                                className="input-width"
                                                                onChange={this.handleFromDate}
                                                                style={styles.calendarStyle}
                                                                formatDate={this.formatDate}
                                                                maxDate={new Date()}
                                                                textFieldStyle={styles.calendarTextStyle}
                                                            />
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="col-sm-3">
                                                    <div className="row input-group" >
                                                        <div className="col-sm-2 activityinput" >
                                                            <i className="fa fa-calendar text-dark " aria-hidden="true"></i>
                                                        </div>
                                                        <div className="col-sm-10 nopadding" >
                                                            <DatePicker hintText="To Date"
                                                                openToYearSelection={true}
                                                                onChange={this.handleToDate}
                                                                container="inline"
                                                                name="activityToDate"
                                                                maxDate={new Date()}
                                                                onFocus={this.removetodate}
                                                                formatDate={this.formatDate}
                                                                className="input-width"
                                                                errorText={todatestate ? null : "To-date should not less than from-date."} />
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="col-sm-2">
                                                    <RaisedButton
                                                        label="Show"
                                                        disabled={this.state.disabled}
                                                        // style={styles.button}
                                                        className="pull-left btn-std"
                                                        backgroundColor="#FFCE39"
                                                        labelColor="#115876"
                                                        onClick={this.handlecardactivity}
                                                        style={{ marginTop: "10px" }}
                                                    />
                                                </div>
                                                {/* {this.state.selectedOption === "tab1" && cardactivity.status === 200 && cardactivity.body.transactions.length > 0 &&
                                                    <div className="col-sm-4 pull-right" style={{}}>

                                                        <RaisedButton
                                                            label="Download As PDF"
                                                            className="pull-right btn-std"
                                                            // disabled={this.state.disabled}
                                                            // style={styles.button}
                                                            backgroundColor="#FFCE39"
                                                            labelColor="#115876"
                                                            onClick={this.handleDownload.bind(this)}
                                                            // icon={<i className="fa fa-download" aria-hidden="true" style={{ marginRight: 10, color: "white" }}></i>}
                                                            style={{ marginTop: "10px" }}
                                                        />
                                                    </div>} */}

                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 transfer" style={{ marginTop: "30px" }}>

                                        <div className="row box-shadow-style" >

                                            <div className="pc-tab">
                                                <input id="tab1" type="radio" name="pct" value="tab1" checked={this.state.selectedOption === 'tab1'} onChange={this.handleChange7.bind(this)} />
                                                <input id="tab2" type="radio" name="pct" value="tab2" checked={this.state.selectedOption === 'tab2'} onChange={this.handleChange8.bind(this)} />
                                                {this.state.selectedOption === "tab1" && cardactivity.status === 200 && cardactivity.body.transactions.length > 0 &&
                                                    <div className="pull-right" style={{ marginRight: "20px" }}>

                                                        <RaisedButton
                                                            label="Download As PDF"
                                                            className="pull-right btn-std"
                                                            // disabled={this.state.disabled}
                                                            // style={styles.button}
                                                            backgroundColor="#FFCE39"
                                                            labelColor="#115876"
                                                            onClick={this.handleDownload.bind(this)}
                                                            // icon={<i className="fa fa-download" aria-hidden="true" style={{ marginRight: 10, color: "white" }}></i>}
                                                            style={{ marginTop: "3px" }}
                                                        />

                                                    </div>}
                                                {this.state.selectedOption === "tab2" && this.state.transactionData && this.state.transactionData.length > 0 &&
                                                    <div className="pull-right" style={{ marginRight: "20px" }}>

                                                        <RaisedButton
                                                            label="Download As PDF"
                                                            className="pull-right btn-std"
                                                            // disabled={this.state.disabled}
                                                            // style={styles.button}
                                                            backgroundColor="#FFCE39"
                                                            labelColor="#115876"
                                                            onClick={this.handleDownloadFailed.bind(this)}
                                                            // icon={<i className="fa fa-download" aria-hidden="true" style={{ marginRight: 10, color: "white" }}></i>}
                                                            style={{ marginTop: "10px" }}
                                                        />
                                                        {/* <button className="btn btn-default" style={{ marginTop: "9px", padding: "3px 6px", fontSize: 14 }}>Download as PDF</button> */}
                                                    </div>}
                                                <nav>
                                                    <ul>
                                                        <li className="tab1">
                                                            <label style={{ cursor: "pointer" }} htmlFor="tab1">Posted Transactions</label>
                                                        </li>
                                                        <li className="tab2">
                                                            <label style={{ cursor: "pointer" }} htmlFor="tab2">Failed Transactions</label>
                                                        </li>
                                                    </ul>
                                                </nav>
                                                <section>
                                                    <div className="tab1" style={{ minHeight: "100px" }}>
                                                        {this.state.quickLoad && <Loader />}
                                                        {this.state.loader === false && cardactivity && cardactivity.status && cardactivity.body && cardactivity.body.transactions ?


                                                            <table className="table table-striped table-responsive" id={"carddivPrint"}>

                                                                <thead className='table-dark'>
                                                                    <tr style={{ fontSize: "13px" }}>
                                                                        <th style={{ width: "6%", verticalAlign: "top", }} >Trans Date</th>
                                                                        <th style={{ width: "10%" }}>Trans Time</th>
                                                                        <th style={{ width: "9%" }}>Trans Ref ID</th>
                                                                        <th style={{ width: "25%", verticalAlign: "top", }}>Description</th>
                                                                        <th style={{ width: "10%" }}>Card Number	</th>
                                                                        <th style={{ width: "10%" }}>Debit <br />(-)</th>
                                                                        <th style={{ width: "10%" }}>Credit <br />(+)</th>
                                                                        <th style={{ width: "10%" }}>Fee <br /> &nbsp;</th>
                                                                        <th style={{ width: "10%" }}>Running Balance</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {

                                                                        (value4 === "all") ?
                                                                            cardactivity.body && cardactivity.body.transactions.length !== 0 && cardactivity.body.transactions.map((value, i) =>
                                                                                <tr style={{ fontSize: "13px" }} key={i}>
                                                                                    <td>{new Date(cardactivity.body.transactions[i].transactionDate).toLocaleDateString('en-GB', {
                                                                                        day: '2-digit', month: '2-digit', year: 'numeric'
                                                                                    })}</td>
                                                                                    <td>{new Date(cardactivity.body.transactions[i].transactionDate).toLocaleTimeString()}</td>
                                                                                    <td>{cardactivity.body.transactions[i].transactionId} </td>
                                                                                    <td style={{ wordBreak: "break-all" }}>{cardactivity.body.transactions[i].typeOfTransfer}<span style={{ fontWeight: "bold" }}> :: </span>{cardactivity.body.transactions[i].comments}  </td>
                                                                                    <td>{cardactivity.body.transactions[i].lastFourDigitsCardNumber}</td>
                                                                                    {(cardactivity.body.transactions[i].debitAmount !== "") ?
                                                                                        <td>{cardactivity.body.transactions[i].debitAmount}</td>
                                                                                        :
                                                                                        <td>{cardactivity.body.transactions[i].debitAmount}</td>
                                                                                    }
                                                                                    {(cardactivity.body.transactions[i].creditAmount !== "") ?
                                                                                        <td>{cardactivity.body.transactions[i].creditAmount}</td>
                                                                                        :
                                                                                        <td>{cardactivity.body.transactions[i].creditAmount}</td>
                                                                                    }
                                                                                    <td> {cardactivity.body.transactions[i].feeAmount}</td>
                                                                                    <td>{cardactivity.body.transactions[i].balanceAmount}</td>
                                                                                </tr>) :
                                                                            (value4 === "debit" && cardactivity.body.hasDebitRecords === true) ?
                                                                                cardactivity.body.transactions.length !== 0 && cardactivity.body.transactions.map((value, i) =>
                                                                                    (cardactivity.body.transactions[i].debitAmount !== "") ?
                                                                                        <tr style={{ fontSize: "13px" }} key={i}>
                                                                                            <td>{cardactivity.body.transactions[i].transferDate}</td>
                                                                                            <td>{cardactivity.body.transactions[i].transferTime} { }</td>
                                                                                            <td>{cardactivity.body.transactions[i].transactionId} </td>
                                                                                            <td style={{ wordBreak: "break-all" }}>{cardactivity.body.transactions[i].typeOfTransfer}<span style={{ fontWeight: "bold" }}> :: </span>{cardactivity.body.transactions[i].comments}  </td>
                                                                                            <td>{cardactivity.body.transactions[i].lastFourDigitsCardNumber}</td>
                                                                                            <td>{cardactivity.body.transactions[i].debitAmount}</td>
                                                                                            <td>{cardactivity.body.transactions[i].creditAmount}</td>
                                                                                            <td> {cardactivity.body.transactions[i].feeAmount}</td>
                                                                                            <td>{cardactivity.body.transactions[i].balanceAmount}</td>
                                                                                        </tr>
                                                                                        :
                                                                                        <tr>
                                                                                        </tr>
                                                                                )
                                                                                :
                                                                                (value4 === "debit" && cardactivity.body.hasDebitRecords === false) ?
                                                                                    <span style={{ fontSize: "20px", position: "absolute", left: "275px" }}>
                                                                                        No Records Found
                                                                                    </span>

                                                                                    :
                                                                                    (value4 === "credit" && cardactivity.body.hasCreditRecords === true) ?
                                                                                        cardactivity.body.transactions.length !== 0 && cardactivity.body.transactions.map((value, i) =>
                                                                                            (cardactivity.body.transactions[i].creditAmount !== "") ?
                                                                                                <tr style={{ fontSize: "13px" }} key={i}>
                                                                                                    <td>{cardactivity.body.transactions[i].transferDate}</td>
                                                                                                    <td>{cardactivity.body.transactions[i].transferTime} { }</td>
                                                                                                    <td>{cardactivity.body.transactions[i].transactionId} </td>
                                                                                                    <td style={{ wordBreak: "break-all" }}>{cardactivity.body.transactions[i].typeOfTransfer}<span style={{ fontWeight: "bold" }}> :: </span>{cardactivity.body.transactions[i].comments}  </td>
                                                                                                    <td>{cardactivity.body.transactions[i].lastFourDigitsCardNumber}</td>
                                                                                                    <td>{cardactivity.body.transactions[i].debitAmount}</td>
                                                                                                    <td>{cardactivity.body.transactions[i].creditAmount}</td>
                                                                                                    <td> {cardactivity.body.transactions[i].feeAmount}</td>
                                                                                                    <td>{cardactivity.body.transactions[i].balanceAmount}</td>
                                                                                                </tr>
                                                                                                :
                                                                                                <tr>
                                                                                                </tr>
                                                                                        ) :
                                                                                        (value4 === "credit" && cardactivity.body.hasCreditRecords === false) ?
                                                                                            <span style={{ fontSize: "20px", position: "absolute", left: "275px" }}>
                                                                                                No Records Found
                                                                                            </span> :
                                                                                            <div>
                                                                                            </div>}







                                                                    {cardactivity.status === 204 &&
                                                                        // <div className="row">
                                                                        //     <span style={{ fontSize: "20px", position: "absolute", left: "275px" }}>
                                                                        //         No Records Found
                                                                        //     </span>


                                                                        // </div>
                                                                        <tr  >
                                                                            <td colspan="9">
                                                                                No Records Found
                                                                            </td>
                                                                        </tr>


                                                                    }

                                                                </tbody>
                                                            </table>
                                                            :
                                                            <Loader />
                                                        }
                                                    </div>
                                                    <div className="tab2" style={{ minHeight: "100px" }} id="carddivPrint1">

                                                        {this.state.quickLoad1 && <Loader />}
                                                        {this.state.loader ? <div ><Loader /></div> :

                                                            <table className="table table-striped table-responsive" style={{ width: "99% " }}  >

                                                                <thead className='table-dark'>
                                                                    <tr style={{ fontSize: "13px" }}>
                                                                        <th style={{ width: "10%", }}>Trans Date & Time</th>
                                                                        <th style={{ width: "10%", }}>Trans Amount</th>
                                                                        <th style={{ width: "10%", }}>Trans Type</th>
                                                                        <th style={{ width: "10%", }}>Card Number</th>
                                                                        <th style={{ width: "10%", }}>Merchant Name</th>
                                                                        <th style={{ width: "10%", }}>Trans Ref Id </th>
                                                                        <th style={{ width: "10%", }}>Rrn </th>
                                                                        <th style={{ width: "20%", }}>Response</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody >
                                                                    {((this.state.transactionData && this.state.transactionData.length > 0) &&
                                                                        this.state.transactionData.map((value, i) =>
                                                                            <tr style={{ fontSize: "13px", padding: "5px !important" }} key={i}>
                                                                                <td >{value.txnDateAndTime}</td>
                                                                                <td >{Number(value.transactionAmount).toFixed(2)} {value.transactionCurrencyCode}</td>
                                                                                <td >{value.transactionType} </td>
                                                                                <td >{value.pan}</td>
                                                                                <td >{value.cardAcceptorNameLocation}</td>
                                                                                <td > {value.transactionId}</td>
                                                                                <td > {value.rrn}</td>
                                                                                <td style={{ wordBreak: "inherit", whiteSpace: "break-spaces" }}> {value.responseCode} - {value.responseMessage}</td>

                                                                            </tr>))
                                                                    }
                                                                    {(this.state.transactionData && this.state.transactionData.length === 0 &&
                                                                        <tr  >
                                                                            <td colspan="8">
                                                                                No Records Found
                                                                            </td>
                                                                        </tr>)}

                                                                </tbody>
                                                            </table>
                                                        }
                                                        {this.state.transactionData && this.state.transactionData.length > 0 &&

                                                            <div className="table-footer">
                                                                <div className="table-pagination-container" style={{ paddong: "15px" }}>
                                                                    {this.state.first === false ?


                                                                        <i className="fa fa-chevron-left  text-center" onClick={this.dec.bind(this)} style={{ cursor: "pointer", fontSize: "18px", color: "black", padding: "10px" }} disabled={this.state.first}></i>
                                                                        :
                                                                        <i disable={this.state.first} className=" fa fa-chevron-left" style={{ color: "grey", fontSize: "18px", padding: "10px" }}></i>
                                                                    }

                                                                    <span className="text-left" style={{ fontSize: "14px", fontWeight: "bold", padding: "10px", color: "black" }}>
                                                                        {this.state.number !== undefined ? this.state.number + 1 : 1}
                                                                    </span>

                                                                    {this.state.last === false ?
                                                                        <i onClick={this.inc.bind(this)} style={{ cursor: "pointer", fontSize: "20px", color: "black", padding: "10px" }} className="fa fa-chevron-right  text-center nopadding"></i>
                                                                        :
                                                                        <i disable={this.state.last} className="fa fa-chevron-right" style={{ color: "grey", fontSize: "20px", padding: "10px" }}></i>
                                                                    }
                                                                </div>

                                                            </div>}
                                                    </div>
                                                </section>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

            </div>



        );
    }
}
Activity.defaultProps = {
    cardState: {
        status: 600
    },
    cardactivity: {
        status: 600
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Activity);


// WEBPACK FOOTER //
// ./src/components/cardsummary/activity.jsx